import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createRavenMiddleware from 'raven-for-redux';
import rootReducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store;
if(process.env.NODE_ENV !== 'development') {
  store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk, createRavenMiddleware(window.Raven, {})))
  );
} else {
  store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
  );
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js